import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { TitleText } from "../../../ui/Text";
import Table from "../../../ui/Table";
import { EditDeleteFormatter } from "../../../ui/TableFormatter";
import Modal from "../../../ui/Modal";
import AddOrganisationForm from "../Organisation/AddOrganisationForm";
import AddOrganizationType from "./AddOrganizationType";
import { GetHook } from "../../../api/api";
import { ORGANISATION_TYPE_URL, ORGANISATION_URL } from "../../../api/urls";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { get } from "../../../utils/get";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import useDebounce from "../../../utils/useDebounce";


const OrganizationTypeSettings = () => {
  const [isModalOpen, setisModalOpen] = useState(false);
  const [handleSubmit, setHandleSubmit] = useState();
  const [editData, setEditData] = useState({});
  const [edit, setEdit] = useState(false);
  const [organisationType, setOrganisationType] = useState([]);
  const { data, error, pending, reload } = GetHook(ORGANISATION_TYPE_URL);
  const [filteredOrgTypes, setFilteredOrgTypes] = useState([]);
  const [filter, setFilter] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [isSearching, setIsSearching] = useState(false);
  const [dataSize, setDataSize] = useState(0);
  const [results, setResults] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const {  availableResultSet } = GetHook(
    `${ ORGANISATION_TYPE_URL}?limit=1`
  );

  const location = useLocation();

  useEffect(() => {
    setOrganisationType(data);
    return () => {};
  }, [data]);
  const handleEdit: any = (row: any) => {
    setisModalOpen(true);
    setEdit(true);
    setEditData(row);
  };

  const handleDelete = (id: string) => {
    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.value) {
        if (id) {
          axios
            .delete(`${ORGANISATION_TYPE_URL}/${id}`)
            .then((res) => {
              setOrganisationType(
                organisationType.filter(
                  (organisationType: any) => organisationType.id != id
                )
              );
              toast.success("Organisation type has been deleted");
              reload(get(location, "key"));
            })
            .catch((error) => toast.error(error.response.data.message));
        }
      }
    });
  };

  const closeModal = () => {
    setisModalOpen(false);
    setEdit(false);
    setEditData({});
    reload(get(location, "key"));
  };

  const debouncedSearchTerm = useDebounce(searchTerm, 500);
  useEffect(() => {
    // Make sure we have a value (user has entered something in input)
    if (debouncedSearchTerm) {
      // Set isSearching state
      setIsSearching(true);
      // Fire off our API call
      axios.get(`${ORGANISATION_TYPE_URL}?name=${debouncedSearchTerm}`).then((res) => {
        // Set back to false since request finished
        setIsSearching(false);
        // Set results state
        setFilteredOrgTypes(res?.data?.returned_resultset);
        setDataSize(res?.data.available_resultset_size);
        setPageCount(Math.ceil(res?.data.available_resultset_size / 10));
      });
    } else {
      setResults([]);
    }
  }, [debouncedSearchTerm]);

  const handleSearch = (e) => {
    if (e?.target.value) {
      setSearchTerm(e.target.value);
      // setFilter({ company: "", organisation: "" });
    } else {
      setFilteredOrgTypes([]);
      setDataSize(0);
      setPageCount(Math.ceil(availableResultSet / 10));
      // console.log({ searchTerm });
    }
  };

  const columns = [
    {
      Header: "Organization Name",
      accessor: "name",
    },
    {
      Header: "Description",
      accessor: "notes",
    },
    {
      id: "1",
      Header: "",
      Cell: ({ row }: any) => (
        <EditDeleteFormatter
          showEdit={() => handleEdit(row.original)}
          handleDelete={() => handleDelete(row.original.id)}
        />
      ),
    },
  ];
  return (
    <OrganizationTypeConatiner>
      <HeaderContainer>
        <TitleText>Organization Type</TitleText>
      </HeaderContainer>
      <Table
        isOrganisationType
        setFilter={setFilter}
        filter={filter}
        data={filteredOrgTypes.length ? filteredOrgTypes : organisationType}
        handleSearch={handleSearch}
        columns={columns}
        setModal={setisModalOpen}
      />
      {isModalOpen && (
        <Modal
          title={edit ? "Edit organisation type" : "Add new Organization type"}
          handleSubmit={handleSubmit}
          closeModal={closeModal}
        >
          <AddOrganizationType
            closseModal={closeModal}
            setHandleSubmit={setHandleSubmit}
            editData={editData}
            organisationTypes={organisationType}
            setOragisationTypes={setOrganisationType}
          />
        </Modal>
      )}
    </OrganizationTypeConatiner>
  );
};

export default OrganizationTypeSettings;

const OrganizationTypeConatiner = styled.div`
  display: grid;
  grid-template-rows: 5em auto;
  background-color: #fff;
`;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1.3em;
  border-bottom: 1px solid rgba(55, 81, 255, 0.1);
`;
const EditIcon = styled.div`
  height: 2em;
  width: 2em;
  padding: 0.5em;
  vertical-align: middle;
  border-radius: 50%;
  &:active {
    background: #f7f8ff;
    /* opacity: 1; */
  }
`;
